<template>

  <div class="table-container">
    <perfect-scrollbar ref="scroll" @ps-y-reach-end="getTradeHistory">
      <table>
        <tr class="header-table">
          <th>بازار</th>
          <th class="hide-400">زمان و تاریخ</th>
          <th>سمت</th>
          <th class="hide-768">نوع</th>
          <th class="hide-992">قیمت واحد</th>
          <th class="hide-992">مقدار</th>
          <th class="hide-768">کارمزد</th>
          <th class="hide-400">مبلغ کل</th>
          <th>سود / زیان</th>
        </tr>

        <tr v-for="(item ,index) in transactions" :key="index">
          <td style="text-align: right">  {{item.orderType.includes('BUY')? $coins[item.destinationCoin].persianName +'-'+  $coins[item.sourceCoin].persianName : $coins[item.sourceCoin].persianName +'-'+  $coins[item.destinationCoin].persianName }}

          </td>
          <td class="hide-400" >{{ $G2J(item.createdAtDateTime) }}</td>
          <td
              :class="{'red' : item.orderType.includes('SELL'), 'green' : item.orderType.includes('BUY') }">
            {{ item.orderType.includes('SELL') ? 'فروش' : 'خرید' }}

          </td>
          <td class="hide-768"
              :class="{'red' : item.orderType.includes('SELL'), 'green' : item.orderType.includes('BUY') }">
            {{ $orderType[item.orderType] }}
          </td>
          <td class="hide-992">{{ $toLocal(item.unitPrice, $decimal['TOMAN']) }}</td>
          <td class="hide-992">{{ item.amount.toLocaleString() }}</td>
          <td class="hide-768">{{ item.wagePercent }}</td>
          <td class="hide-400">{{ $toLocal(item.calculatedPriceInTomanMarket, $decimal['TOMAN']) }}</td>
<td>0</td>
        </tr>
      </table>

    </perfect-scrollbar>

  </div>



</template>

<script>
export default {
  name: "tradeHistory",
  props:['query'],
  marketType:'BITCOIN_TOMAN',
  data() {
    return {
      transactions:[],
      page:0,
      lastPage:1,
      tradeHistoryheader: ['بازار', 'زمان و تاریخ', 'سمت', 'نوع', 'قیمت واحد', 'مقدار', 'کارمزد', 'مبلغ کل', ' سود / زیان'],
      //trade data table
    }
  },
  watch:{

    'query'() {
      let query = this.query

if(query.startDate && query.endDate !==''){
  // console.log(new Date(query.startDate) , new Date(query.endDate))

const filteredToDates = this.transactions.filter(
  (record)=>{
    return new Date(record.createdAtDateTime) >= new Date(query.startDate) && new Date(record.createdAtDateTime) <= new Date(query.endDate)
  }
)

console.log(filteredToDates)
}




      if(!query.descendingDate){
        this.transactions= this.transactions.sort((a,b)=>{ return new Date(a.createdAtDateTime)  - new Date(b.createdAtDateTime)})
      }
      else if(query.descendingDate){
        this.transactions= this.transactions.sort((a,b)=>{ return new Date(b.createdAtDateTime)  - new Date(a.createdAtDateTime)})

      }








      if(query.coin.coin == ''){







        return this.transactions
      }
//
      else if(query.coin){

this.marketType = query.coin[0] + '_' + query.baseCoin










        this.state.loading=true;

        const res = this.$axios.get('/trades/',{
         params:{
           marketType:this.marketType,
           size:20,
           page:this.page,
           type:'P2P',

         }
       }).then(res=> {
         console.log(res.content)
         // return (this.transactions = res.content})

         if(query.tradeType =='BUY'){

         return  this.transactions = res.content.filter(item=>item.orderType.includes('BUY'))
         }

         else return this.transactions = res.content.filter(item=>item.orderType.includes('SELL'))

       })




        // this.transactions=  this.transactions.filter(transaction => {
        //   return transaction.marketType == query.coin[0] + '_' + quer
        // })



      }










      else return this.transactions
    },


  },
  methods:{
   async getTradeHistory() {


        if (this.page <= this.lastPage) {
        this.page++
        let res = await this.$axios.get('/trades', {
          params: {
            // marketType: this.$route.params.tradeFrom + '_' + this.$route.params.tradeTo,
            marketType : this.marketType,
            type:'P2P',
            page: this.page,
            size: 20
          }
        })

        // res.content = res.content.filter(i => !i.orderType.includes('EXCHANGE'));
console.log('trade history is here', res.content)
this.transactions = res.content;
      }

    },
  },


  mounted(){
this.getTradeHistory()

  },
}
</script>

<style lang="scss" scoped>
.table-container{
  height: 300px;
  overflow-y: scroll;
}

.red{
  color:red;
}
.green{
  color: green;
}
table{
  table-layout: fixed;

  th {
    font-size: clamp(10px , 1vw , 14px);
    color: #D7C8C8;
    background-color: #091222;
    text-align: center;

    &:first-child{
      text-align: right !important;
    }

    &:last-child{
      text-align: left !important;
    }
  }

  td {
    font-size: clamp(10px , 1vw , 14px);
    color: #D7C8C8;
    height:40px;
    text-align: center;

    &:first-child{
      text-align: right !important;
    }

    &:last-child{
      text-align: left !important;
    }
  }

  .header-table{
    height: 65px;
    position: sticky;
    top: 0;
  }

  .body{
    &:first-child{
      text-align: right !important;
    }

    &:last-child{
      text-align: left !important;
    }
  }
}


@media (max-width: 992px) {
  .hide-992{
    display:none !important;
  }
}

@media (max-width: 768px) {
  .hide-768{
    display:none !important;
  }
}

@media (max-width: 400px) {
  .hide-400{
    display:none !important;
  }
}
</style>